export const UPLOAD_BROADCAST_EMAIL_ATTACHMENT_START = 'UPLOAD_BROADCAST_EMAIL_ATTACHMENT_START';
export const UPLOAD_BROADCAST_EMAIL_ATTACHMENT_SUCCESS = 'UPLOAD_BROADCAST_EMAIL_ATTACHMENT_SUCCESS';
export const UPLOAD_BROADCAST_EMAIL_ATTACHMENT_ERROR = 'UPLOAD_BROADCAST_EMAIL_ATTACHMENT_ERROR';
